import { AnimatePresence, motion } from 'framer-motion';
import type { LucideIcon } from 'lucide-react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface AccordionMobileProps {
  icon: LucideIcon;
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const AccordionMobile = ({
  icon: Icon,
  title,
  isOpen,
  onToggle,
  children,
}: AccordionMobileProps) => {
  return (
    <div className="w-full overflow-hidden rounded-[10px] border border-border-subtle bg-surface-primary">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full cursor-pointer items-center justify-between px-4 py-3.5"
      >
        <div className="flex flex-1 items-center gap-2.5">
          <Icon className="h-[18px] w-[18px] shrink-0 text-accent-primary" />
          <span className="font-body text-[13px] font-semibold leading-[1.3] text-foreground-primary">
            {title}
          </span>
        </div>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
          className="shrink-0"
        >
          {isOpen ? (
            <ChevronUp className="h-[18px] w-[18px] text-foreground-tertiary" />
          ) : (
            <ChevronDown className="h-[18px] w-[18px] text-foreground-tertiary" />
          )}
        </motion.div>
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <div className="px-4 pb-4">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AccordionMobile;
